import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styling/TermsOfService.css';
import { NavigationBar } from '../Components/NavigationBar/NavigationBar';
import Footer from '../Components/Footer/Footer';

const TermsOfService = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/profile');
    };

    return (
        <div className="terms-container">
            <NavigationBar onBackClick={handleBack} title="Termos de Serviço" />
            <div className="terms-content">
                <h1>Termos de Serviço</h1>

                <div className="terms-section">
                    <h2>1. Aceitação dos Termos</h2>
                    <p>
                        Ao acessar ou utilizar a plataforma Reino Play, você concorda em cumprir estes Termos de Serviço e todas as leis e regulamentos aplicáveis. Se você não concordar com estes termos, recomendamos que não utilize nossos serviços.
                    </p>
                </div>

                <div className="terms-section">
                    <h2>2. Descrição do Serviço</h2>
                    <p>
                        O Reino Play é uma plataforma de streaming dedicada a conteúdos bíblicos infantis. Oferecemos:
                    </p>
                    <ul>
                        <li>Streaming de vídeos sob demanda;</li>
                        <li>Conteúdos exclusivos e educativos de cunho cristão;</li>
                        <li>Disponibilidade em múltiplos dispositivos;</li>
                    </ul>
                </div>

                <div className="terms-section">
                    <h2>3. Conta do Usuário</h2>
                    <p>Ao criar uma conta no Reino Play, você concorda em:</p>
                    <ul>
                        <li>Fornecer informações verdadeiras, atualizadas e completas;</li>
                        <li>Manter a confidencialidade das suas credenciais de acesso;</li>
                        <li>Não compartilhar sua conta com terceiros;</li>
                        <li>Ser maior de 18 anos ou ter permissão dos responsáveis legais.</li>
                    </ul>
                </div>

                <div className="terms-section">
                    <h2>4. Pagamentos, Assinaturas e Cancelamento</h2>
                    <p>
                        A assinatura do Reino Play é processada de forma segura por meio da plataforma <strong>Greenn</strong>.
                        Ao assinar um plano pago, você concorda com os seguintes termos:
                    </p>
                    <ul>
                        <li>As cobranças são feitas de forma recorrente, conforme o plano escolhido (mensal, anual etc.);</li>
                        <li>O cancelamento pode ser feito a qualquer momento via área do usuário ou diretamente pela plataforma Greenn;</li>
                        <li>O acesso ao conteúdo permanecerá ativo até o fim do ciclo atual da assinatura;</li>
                        <li>Não realizamos reembolsos parciais, exceto em casos exigidos por lei;</li>
                        <li>É responsabilidade do usuário manter as informações de pagamento atualizadas.</li>
                    </ul>
                </div>

                <div className="terms-section">
                    <h2>5. Propriedade Intelectual</h2>
                    <p>
                        Todo o conteúdo exibido no Reino Play, incluindo vídeos, textos, imagens, músicas e ilustrações, é protegido por direitos autorais e pertence exclusivamente ao Reino Play ou a seus licenciadores. É proibida a reprodução, distribuição ou qualquer uso não autorizado do conteúdo.
                    </p>
                </div>

                <div className="terms-section">
                    <h2>6. Modificações nos Termos</h2>
                    <p>
                        O Reino Play pode alterar estes Termos de Serviço periodicamente. Quaisquer alterações serão comunicadas por meio da plataforma ou por e-mail. O uso contínuo dos nossos serviços após tais alterações constitui sua aceitação dos novos termos.
                    </p>
                </div>

                <div className="terms-section">
                    <h2>7. Contato</h2>
                    <p>
                        Em caso de dúvidas, sugestões ou solicitações, entre em contato conosco pelo e-mail <a href="mailto:suporte@reinoplay.com.br">suporteturminha@gmail.com</a>.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TermsOfService;
